import { Route, Routes } from "react-router-dom";

import TeamCreateScreen from "screens/App/CRM/Team/TeamCreateScreen";
import TeamDetailScreen from "screens/App/CRM/Team/TeamDetailScreen";
import TeamEditScreen from "screens/App/CRM/Team/TeamEditScreen";
import TeamListScreen from "screens/App/CRM/Team/TeamListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const TeamRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<TeamCreateScreen />} />
      <Route path=":id/edit" element={<TeamEditScreen />} />
      <Route path=":id/detail" element={<TeamDetailScreen />} />
      <Route path="list" element={<TeamListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default TeamRouter;
